import {
  Box,
  Button,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import Header from "../../../../components/Header";
import { tokens } from "../../../../theme";
import { useTheme } from "@mui/material";
import {
  uploadDocument,
} from "../../../../data/Axios/DynamicService";
import { documentUploadUrl } from "../../../../config";
import { useDispatch } from "react-redux";
import { UpdateDataToStore } from "../../../../store/Actions/CustomAction";

const DocumentUploadForm = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const base_url = documentUploadUrl.uri;
  const base_url2 = documentUploadUrl.uri2;
   const base_url3 = documentUploadUrl.uri3;

  const dispatch = useDispatch();

  const initialValues = {
    courtId: props.data ? props.data.courtId : "",
  };

  const validationSchema = yup.object().shape({
    file: yup
      .mixed()
      .required("Please select a file to upload!")
      .test("fileSize", "The file has exceeded the 50mb limit", value => {
        return value && value.size <= 52428800;
      })
  });

  const caseIdFromSession = JSON.parse(localStorage.getItem("CaseId"));
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userIdFromSession = parseInt(decodedToken.Id);


  const FILE_GATEWAY_URL = "https://api.sheriapro.sababisha.com"; // Replace with your actual file gateway URL
const FILE_STORAGE_API_KEY = "E3VF4C6KFV43JH6GKCDFGJP45V36JHGV3H4C6F3GJC63HG405GH6V345GHHJ4623FJJL3HCVMO1P23PZ07W8"; // see note below

const uploadFileToStorage = async (file, project = "SheriaPro", folder = "cases") => {
  const form = new FormData();
  form.append("file", file);
  form.append("project", project);
  form.append("folder", folder);

  const response = await fetch(`${FILE_GATEWAY_URL}/filestorageservice/upload`, {
    method: "POST",
    headers: { "X-Api-Key": FILE_STORAGE_API_KEY },
    body: form,
  });
  if (!response.ok) throw new Error(`Upload failed (${response.status})`);
  return await response.json();
};

const handleSubmit = async (values, { setSubmitting, resetForm }) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({ icon: "error", title: "Authentication Error", text: "You are not logged in. Please login and try again." });
      setSubmitting(false);
      return;
    }

    const minioResult = await uploadFileToStorage(values.file, "SheriaPro", "cases");

    const response = await fetch(`${base_url3}/SaveCaseDocumentMinio`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token.replace(/"/g, "")}`,
      },
      body: JSON.stringify({
        caseId: caseIdFromSession,
        documentName: values.file.name,
        fileName: minioResult.fileName,
        objectName: minioResult.objectName,
        url: minioResult.url,
        mimeType: values.file.type,
        fileSizeBytes: values.file.size,
      }),
    });

    if (response.ok) {
      props.onClose();
      props.onAction();

        props.refetchData();
      Swal.fire({ icon: "success", title: "Success!", text: "Document uploaded successfully." });
      dispatch(UpdateDataToStore("REFRESH_DOCUMENTS_TABLE", "success"));
      resetForm();
    } else {
      Swal.fire({ icon: "error", title: "Upload Failed", text: "There was an issue uploading the document. Please try again." });
    }
  } catch (error) {
    Swal.fire({ icon: "error", title: "Error!", text: "An error occurred while processing your request." });
    dispatch(UpdateDataToStore("REFRESH_DOCUMENTS_TABLE", "error"));
  }
  setSubmitting(false);
};
  // const handleSubmit = async (values, { setSubmitting, resetForm }) => {
  //   try {

  //     const token = localStorage.getItem("token");

  //     if (!token) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Authentication Error",
  //         text: "You are not logged in. Please login and try again.",
  //       });
  //       setSubmitting(false);
  //       return;
  //     };

  //     const caseEventObject = {
  //       caseId: caseIdFromSession,
  //       createdBy: userIdFromSession,
  //     };

  //     console.log("Uploading document with:",{
  //       action: props.isEditing ? "remove" : "add",
  //       file: values.file,
  //       caseEventObject,
  //       base_url
  //     });

  //     const response = await uploadDocument(
  //       props.isEditing ? "remove" : "add",
  //       values.file,
  //       caseEventObject,
  //       base_url
  //     );

  //     console.log("Upload response:", response);

  //     if (response == 200 || response?.status == 200) {
  //       props.onClose();
  //       props.onAction()
  //       Swal.fire({
  //         icon: "success",
  //         title: "Success!",
  //         text: `Document uploaded successfully.`,
  //       });
  //       const actionKey = "REFRESH_DOCUMENTS_TABLE";
  //       dispatch(UpdateDataToStore(actionKey, "success"));
  //       resetForm();
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Upload Failed",
  //         text: "There was an issue uploading the document. Please try again.",
  //       });
  //     }

  //     setSubmitting(false);
  //   } catch (error) {
  //     console.error("Upload error:", error);

  //     let errorMessage = "An unexpected error occurred. Please try again later.";

  //     if (error.response?.status === 401 || error.status === 401) {
  //       errorMessage = "Authentication failed. Please login again.";

  //     } else if (error.response?.status === 413) {
  //       errorMessage = "The selected file is too large.";
  //     } else if (error.response?.status === 415) {
  //       errorMessage = "The selected file format is not supported.";
  //     } else if (error.message) {
  //       errorMessage = error.message;
  //     }

  //     Swal.fire({
  //       icon: "error",
  //       title: "Error!",
  //       text: "An error occurred while processing your request. Please try again later.",
  //     });
  //     const actionKey = 'REFRESH_DOCUMENTS_TABLE'
  //     dispatch(UpdateDataToStore(actionKey, 'error'));
  //     setSubmitting(false);
  //   }
  // };

  const isNonMobile = useMediaQuery("(min-width:600px)");

  return (
    <Box m="20px">
      <Header
        title={
          props.isEditing ? "Remove document" : "Upload documents"
        }
        subtitle={
          props.isEditing
            ? "Remove the document from the case"
            : "Add a document to the case"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit} enctype="multipart/form-data">
            <Button
              variant="contained"
              component="label"
              sx={{
                marginTop: "1rem",
                bgcolor: `${colors.grey[400]}`
              }}
            >
              Select a file to upload
              <input
                id="file"
                name="file"
                type="file"
                hidden
                onChange={(event) => {
                  setFieldValue("file", event.currentTarget.files[0]);
                }}
              />
            </Button>
            {touched.file && errors.file ? (
              <Typography color="error">{errors.file}</Typography>
            ) : null}
            {values.file && (
              <Typography sx={{ margin: "1rem" }}>{values.file.name}</Typography>
            )}

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box >
  );
};

export default DocumentUploadForm;
